import React from 'react';
import ItemPage from '../components/ItemPage';

const Item = () => {
  return <ItemPage />;
};

export default Item;
